import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyMarmaladeIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./MarmaladeIcon-94a2cb3b.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyMarmaladeIcon as P };
